import { StrictMode } from 'react'
import './i18n'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import App from './App.tsx'
import i18n from './i18n'

const container = document.getElementById('root')!

const app = (
  <StrictMode>
    <BrowserRouter basename={__BASE_PATH__}>
      <App i18n={i18n} />
    </BrowserRouter>
  </StrictMode>
)

if (container.hasChildNodes()) {
  hydrateRoot(container, app)
} else {
  createRoot(container).render(app)
}
